import { render, staticRenderFns } from "./emptyRouterComponent.vue?vue&type=template&id=7674a90a&scoped=true&lang=pug"
import script from "./emptyRouterComponent.vue?vue&type=script&lang=js"
export * from "./emptyRouterComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7674a90a",
  null
  
)

export default component.exports